import { CSSObject } from '@chakra-ui/react';
import { RaceCardSchema } from './RaceCards.styles';

export const raceCardStyles: RaceCardSchema = {
  GridRaceCards: {
    my: '2',
    mb: '3',
    fontFamily: 'accent',
  },
  FlexCard: {
    my: '1',
    borderRadius: 'lg',
    bgGradient: 'linear(180deg, beta.400 0%, beta.500 100%)',
    boxShadow: '0px 7px 20px 0px #0000004D, 0px 0px 0px 1px #FFFFFF1A inset',
  },
  LinkCardHeader: {
    bg: 'transparent',
    color: 'beta.400',
    sx: {
      '&&&&': {
        '.chakra-badge': {
          pt: '1',
          lineHeight: 'normal',
        },
      },
    },
  },
  TextCardHeading: {
    color: 'white',
    fontSize: '0.8125rem',
    fontWeight: 'semibold',
    textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
  },
  TextRaceNumber: {
    bg: 'gray.300',
    borderRadius: 'sm',
    color: 'gray.600',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
    lineHeight: 'normal',
    fontSize: '8px',
    pt: '2px',
  },
  GridCardContent: {
    color: 'blackAlpha.400',
    fontSize: 'sm',
    p: '0',
  },
  BoxGridHeaderItem: {
    bg: 'blackAlpha.400',
    color: 'white',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    lineHeight: '1.4',
    borderTop: '2px solid',
    borderColor: 'alpha.300',
    fontSize: '0.5rem',
    px: '2',
  },
  FlexGridRunnerItem: {
    bg: 'transparent',
    borderBottom: '1px dashed',
    borderBottomColor: 'blackAlpha.300',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
    px: '2',
    minH: '44px',
  },
  TextRunner: {
    fontSize: 'xs',
    color: 'white',
    fontWeight: 'bold',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
  },
  TextRunnerNumber: {
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    sx: {
      _last: {
        fontSize: '2xs',
        fontWeight: 'normal',
        pos: 'relative',
        top: '-2px',
      },
    },
  },
  TextScratched: {
    color: 'white',
  },
  LinkRaceDetails: {
    color: 'blackAlpha.800',
    bg: 'linear-gradient(180deg, var(--bc-colors-alpha-300), var(--bc-colors-alpha-500))',
    border: '2px solid',
    borderColor: 'alpha.300',
    boxShadow: '0px 3px 4px 0px #00000033',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
    position: 'relative',
    m: '2',
    py: '2.5',
    borderRadius: 'md',
    fontFamily: 'accent',
    fontSize: '0.6875rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    transition: 'all .2s ease-in-out',
    _hover: {
      bg: 'linear-gradient(180deg, var(--bc-colors-alpha-500), var(--bc-colors-alpha-300))',
    },
    _disabled: {
      opacity: 0.4,
      pointerEvents: 'none',
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    },
  },
  buttonRaceCardOddsProps: {
    variant: 'odds',
    fontSize: 'xs',
    h: '8',
    w: '42px',
    transition: 'all 0.4s ease-in-out',
  },
};

export const TextRunner: CSSObject = {
  color: 'white',
};

export const IconCardHeader: CSSObject = {
  color: 'alpha.300',
};
